import { render, staticRenderFns } from "./ConsultaPago.vue?vue&type=template&id=af5ca774&scoped=true"
import script from "./ConsultaPago.vue?vue&type=script&lang=js"
export * from "./ConsultaPago.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPago.vue?vue&type=style&index=0&id=af5ca774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5ca774",
  null
  
)

export default component.exports